<template>
  <div>
    <!-- ******************* -->
    <!-- *      Modal      * -->
    <!-- ******************* -->
    <!-- This modal is for creating new checks -->
    <div
      class="modal fade"
      id="addChecksDialog"
      data-backdrop="static"
      data-keyboard="false"
    >
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header">
            <!-- Close button in the upper right corner -->
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-hidden="true"
            >
              ×
            </button>

            <!-- Modal Title -->
            <h4 class="modal-title">
              <b>{{ lang.CM2000 }}</b>
            </h4>
          </div>
          <div class="modal-body">
            <div class="panel panel-default" id="add-checks-top-panel">
              <div class="panel-body">
                <div
                  class="col-md-2"
                  v-if="
                    !feature.isAudiTarget ||
                    !feature.isEnabled('audi_importers')
                  "
                >
                  <div class="form-group">
                    <select2
                      id="check-management-create-clients"
                      class="form-control"
                      v-model="selectedClientLocal"
                      @change="$emit('clientSelected', selectedClientLocal)"
                      :placeholder="lang.CM2001"
                      :allowClear="true"
                    >
                      <option></option>
                      <option
                        v-for="client in dataLists.clientList"
                        :key="client.ClientGuid"
                        :value="client.ClientGuid"
                      >
                        {{ client.ClientName }}
                      </option>
                    </select2>
                  </div>
                </div>
                <div
                  :class="
                    !feature.isAudiTarget ||
                    !feature.isEnabled('audi_importers')
                      ? 'col-md-2'
                      : 'col-md-4'
                  "
                >
                  <div class="form-group">
                    <select2
                      id="check-management-create-projects"
                      class="form-control"
                      v-model="selectedProjectLocal"
                      :disabled="!selectedClientLocal"
                      :placeholder="lang.CM2002"
                      :allowClear="true"
                    >
                      <option></option>
                      <option
                        v-for="project in projectsOfClient"
                        :key="project.ProjectGuid"
                        :value="project.ProjectGuid"
                      >
                        {{ project.ProjectName }}
                      </option>
                    </select2>
                  </div>
                </div>
                <div class="col-md-2">
                  <div class="form-group">
                    <select2
                      id="check-management-create-surveys"
                      class="form-control"
                      v-model="selectedSurvey"
                      :disabled="!selectedProjectLocal"
                      :placeholder="lang.CM2003"
                      :allowClear="true"
                    >
                      <option></option>
                      <option
                        v-for="survey in surveysOfProject"
                        :key="survey.SurveyId"
                        :value="survey.SurveyId"
                      >
                        {{ survey.SurveyTitle }}
                      </option>
                    </select2>
                  </div>
                </div>
                <div class="col-md-2">
                  <div class="form-group">
                    <select2
                      id="check-management-create-waves"
                      class="form-control"
                      v-model="selectedWave"
                      :disabled="!selectedProjectLocal"
                      :placeholder="lang.CM2004"
                      :allowClear="true"
                    >
                      <option></option>
                      <option
                        v-for="wave in wavesOfProject"
                        :key="wave.WaveGuid"
                        :value="wave.WaveGuid"
                      >
                        {{ wave.WaveName }}
                      </option>
                    </select2>
                  </div>
                </div>
                <div class="col-md-2">
                  <div class="form-group">
                    <select2
                      id="check-management-create-scenarios"
                      class="form-control"
                      v-model="selectedScenario"
                      :disabled="!selectedWave"
                      :placeholder="lang.CM2005"
                      :allowClear="true"
                    >
                      <option></option>
                      <option
                        v-for="scenario in scenariosOfWave"
                        :key="scenario.ScenarioGuid"
                        :value="scenario.ScenarioGuid"
                      >
                        {{ scenario.ScenarioName }}
                      </option>
                    </select2>
                  </div>
                </div>
                <div
                  class="col-md-2"
                  v-if="
                    feature.isAudiTarget && feature.isEnabled('leadAgencies')
                  "
                >
                  <div class="form-group">
                    <select2
                      id="check-management-create-lead-agency"
                      class="form-control"
                      v-model="selectedAgency"
                      :placeholder="lang.CM2013"
                      :allowClear="true"
                      @change="selectedUser = ''"
                    >
                      <option></option>
                      <option
                        v-for="agency in leadAgencies"
                        :key="agency.AgencyGuid"
                        :value="agency.AgencyGuid"
                      >
                        {{ agency.AgencyName }}
                      </option>
                    </select2>
                  </div>
                </div>
                <div class="col-md-2" v-else>
                  <div class="form-group">
                    <select2
                      id="check-management-create-check-types"
                      class="form-control"
                      v-model="selectedCheckType"
                      :placeholder="lang.CM2031"
                      :allowClear="true"
                      @change="(selectedUser = ''), (selectedAgency = '')"
                    >
                      <option value="FO">{{ lang.CM2032 }}</option>
                      <option value="MA">{{ lang.CM2033 }}</option>
                      <option value="AG">{{ lang.CM2034 }}</option>
                    </select2>
                  </div>
                </div>

                <div class="col-md-2">
                  <div
                    class="form-group"
                    v-if="feature.isEnabled('briefingAndSurveyDocs')"
                  >
                    <select2
                      class="form-control"
                      v-model="selectedBriefingGuid"
                      :placeholder="lang.CM2029"
                      :allowClear="true"
                      :disabled="!selectedProjectLocal"
                    >
                      <option></option>
                      <option
                        v-for="briefing in briefingAttachments"
                        :key="briefing.DownloadId"
                        :value="briefing.DownloadId"
                      >
                        {{ briefing.FileName }}
                      </option>
                    </select2>
                  </div>
                </div>
                <div class="col-md-2">
                  <div
                    class="form-group"
                    v-if="feature.isEnabled('briefingAndSurveyDocs')"
                  >
                    <select2
                      class="form-control"
                      v-model="selectedSurveyGuid"
                      :placeholder="lang.CM2030"
                      :allowClear="true"
                      :disabled="!selectedProjectLocal"
                    >
                      <option></option>
                      <option
                        v-for="survey in surveyAttachments"
                        :key="survey.DownloadId"
                        :value="survey.DownloadId"
                      >
                        {{ survey.FileName }}
                      </option>
                    </select2>
                  </div>
                </div>
                <div class="col-md-2">
                  <div class="form-group input-form-group">
                    <label
                      for="inputGlobalAmount"
                      class="col-md-4 control-label"
                      >{{ lang.CM2009 }}</label
                    >
                    <div class="col-md-8">
                      <input
                        type="number"
                        min="0"
                        class="form-control"
                        id="inputGlobalAmount"
                        v-model.number="globalAmount"
                      />
                    </div>
                  </div>
                </div>

                <div class="col-md-4">
                  <div class="form-group input-form-group">
                    <input
                      class="form-control"
                      maxlength="50"
                      :placeholder="lang.CM2044"
                      v-model="checkInfo"
                    />
                  </div>
                </div>

                <div
                  class="col-md-2"
                  v-if="selectedCheckType === 'AG' && !feature.isAudiTarget"
                >
                  <div class="form-group">
                    <select2
                      class="form-control"
                      v-model="selectedAgency"
                      :placeholder="lang.CM2013"
                      :allowClear="true"
                      @change="selectedUser = ''"
                    >
                      <option></option>
                      <option
                        v-for="agency in dataLists.agencyList"
                        :key="agency.AgencyGuid"
                        :value="agency.AgencyGuid"
                      >
                        {{ agency.AgencyName }}
                      </option>
                    </select2>
                  </div>
                </div>
                <div class="col-md-2" v-else-if="selectedCheckType === 'MA'">
                  <div class="form-group">
                    <select2
                      class="form-control"
                      v-model="selectedUser"
                      :placeholder="lang.CM2006"
                      :allowClear="true"
                      @change="selectedAgency = ''"
                    >
                      <option></option>
                      <option
                        v-for="(user, key) in dataLists.shopperList"
                        :key="key"
                        :value="key"
                      >
                        {{ user }}
                      </option>
                    </select2>
                  </div>
                </div>
                <div
                  class="col-md-2"
                  v-if="
                    selectedCheckType === 'FO' &&
                    feature.isEnabled('freeOffers')
                  "
                >
                  <div class="form-group form-group-buttons">
                    <a
                      type="button"
                      class="btn btn-raised"
                      @click="showFurtherSettingsModal = true"
                    >
                      <span>{{ lang.CM2038 }}</span>
                    </a>
                  </div>
                </div>
              </div>

              <div class="panel-body">
                <div class="col-md-4">
                  <div class="form-group searchbar">
                    <input
                      type="text"
                      class="form-control"
                      id="inputSearchAddChecks"
                      :placeholder="lang.CM2014"
                      v-model="filterStrings.Search"
                      @keyup.enter="(selectedPage = 1), getLocationData()"
                    />
                  </div>
                </div>

                <div class="col-md-2 last-row-button-container">
                  <div class="form-group form-group-buttons">
                    <a
                      role="button"
                      class="btn btn-raised"
                      @click="clearFilter()"
                    >
                      <span>{{ lang.CM2010 }}</span>
                    </a>
                    <a
                      role="button"
                      class="btn btn-raised"
                      @click="togglePageSelected()"
                    >
                      <span v-if="!isPageSelected()">{{ lang.CM2011 }}</span>
                      <span v-else>{{ lang.CM2012 }}</span>
                    </a>
                  </div>
                </div>

                <div class="col-md-2 last-row-button-container">
                  <span class="selected-locations-counter">
                    {{ lang.CM2037 }}: {{ selectedLocations.length || 0 }}
                    <template v-if="selectedLocations.length">
                      <a
                        role="button"
                        class="btn btn-raised"
                        @click="selectedLocations = []"
                        >{{ lang.CM2036 }}</a
                      >
                    </template>
                  </span>
                </div>

                <div class="col-md-4 nopadding">
                  <!-- Pagination -->
                  <ul class="pagination-fonts pagination btn-group">
                    <li>
                      <!-- Dropdown: Select the number of elements per page -->
                      <a
                        role="button"
                        class="dropdown-toggle"
                        data-toggle="dropdown"
                        id="elementsPerPageDropdownAddChecks"
                      >
                        <i class="material-icons md-18">view_headline</i>
                      </a>
                      <b-tooltip
                        ref="tooltip"
                        target="elementsPerPageDropdownAddChecks"
                        :delay="globals.tooltipDelay"
                        >{{ lang.CM2015 }}</b-tooltip
                      >
                      <ul class="dropdown-menu">
                        <!-- Add dropdown entries here -->
                        <li>
                          <a
                            class="dropdown-element"
                            v-bind:class="{ 'dropdown-active': pageSize == 20 }"
                            role="button"
                            @click="updatePaging(1, 20)"
                            >20</a
                          >
                        </li>
                        <li>
                          <a
                            class="dropdown-element"
                            v-bind:class="{ 'dropdown-active': pageSize == 50 }"
                            role="button"
                            @click="updatePaging(1, 50)"
                            >50</a
                          >
                        </li>
                        <li>
                          <a
                            class="dropdown-element"
                            v-bind:class="{
                              'dropdown-active': pageSize == 100,
                            }"
                            role="button"
                            @click="updatePaging(1, 100)"
                            >100</a
                          >
                        </li>
                        <li>
                          <a
                            class="dropdown-element"
                            v-bind:class="{
                              'dropdown-active': pageSize == 200,
                            }"
                            role="button"
                            @click="updatePaging(1, 200)"
                            >200</a
                          >
                        </li>
                        <li>
                          <a
                            class="dropdown-element"
                            v-bind:class="{
                              'dropdown-active': pageSize == 500,
                            }"
                            role="button"
                            @click="updatePaging(1, 500)"
                            >500</a
                          >
                        </li>
                        <li>
                          <a
                            class="dropdown-element"
                            v-bind:class="{
                              'dropdown-active': pageSize == 1000,
                            }"
                            role="button"
                            @click="updatePaging(1, 1000)"
                            >1000</a
                          >
                        </li>
                      </ul>
                    </li>

                    <!-- Jump to first page -->
                    <li
                      v-bind:class="{
                        disabled: !pageCount || selectedPage == 1,
                      }"
                      @click="updatePaging(1, 0)"
                    >
                      <a role="button" id="firstPageButtonAddChecks">
                        <i class="material-icons md-18">first_page</i>
                      </a>
                      <b-tooltip
                        ref="tooltip"
                        target="firstPageButtonAddChecks"
                        :delay="globals.tooltipDelay"
                        >{{ lang.CM2016 }}</b-tooltip
                      >
                    </li>
                    <!-- ... -->
                    <li
                      v-if="pageCount > 7 && selectedPage > 4"
                      class="disabled"
                    >
                      <a role="button">...</a>
                    </li>
                    <!-- Pagenumbers -->
                    <li
                      v-for="pageNumber in getVisiblePages()"
                      :key="pageNumber"
                      v-bind:class="{ active: selectedPage == pageNumber }"
                      @click="updatePaging(pageNumber, 0)"
                    >
                      <a role="button">{{ pageNumber }}</a>
                    </li>
                    <!-- ... -->
                    <li
                      v-if="pageCount > 7 && selectedPage < pageCount - 3"
                      class="disabled"
                    >
                      <a role="button">...</a>
                    </li>
                    <!-- Jump to last page -->
                    <li
                      v-bind:class="{
                        disabled: !pageCount || selectedPage == pageCount,
                      }"
                      @click="updatePaging(pageCount, 0)"
                    >
                      <a role="button" id="lastPageButtonAddChecks">
                        <i class="material-icons md-18">last_page</i>
                      </a>
                      <b-tooltip
                        ref="tooltip"
                        target="lastPageButtonAddChecks"
                        :delay="globals.tooltipDelay"
                        >{{ lang.CM2017 }}</b-tooltip
                      >
                    </li>
                    <li class="disabled">
                      <a role="button" id="addChecksTotalElementsCounter">{{
                        totalElementsCount
                      }}</a>
                      <b-tooltip
                        ref="tooltip"
                        target="addChecksTotalElementsCounter"
                        :delay="globals.tooltipDelay"
                        >{{ lang.CM2045 }}</b-tooltip
                      >
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            <!-- ******************* -->
            <!-- *      Table      * -->
            <!-- ******************* -->
            <!-- This is the main panel on the page where all data is displayed in a table -->
            <div class="panel panel-default locations-table-panel">
              <div class="panel-body">
                <table
                  class="table table-striped table-hover main-table"
                  id="possibleLocations"
                >
                  <thead>
                    <tr>
                      <!-- Add table headers here -->
                      <!-- The table sort is triggered by click on the header -->
                      <th style="width: 8%" class="text-center">
                        <a
                          class="table-header"
                          role="button"
                          @click="sortLocationData('LocationId')"
                        >
                          {{ lang.CM2018 }}
                          <span
                            v-if="
                              sortField == 'LocationId' && sortOrder == 'asc'
                            "
                            class="glyphicon glyphicon-triangle-top"
                          ></span>
                          <span
                            v-if="
                              sortField == 'LocationId' && sortOrder == 'desc'
                            "
                            class="glyphicon glyphicon-triangle-bottom"
                          ></span>
                        </a>
                      </th>
                      <th style="width: 8%" class="text-center">
                        <a
                          class="table-header"
                          role="button"
                          @click="sortLocationData('LocationStoreId')"
                        >
                          {{ lang.CM2019 }}
                          <span
                            v-if="
                              sortField == 'LocationStoreId' &&
                              sortOrder == 'asc'
                            "
                            class="glyphicon glyphicon-triangle-top"
                          ></span>
                          <span
                            v-if="
                              sortField == 'LocationStoreId' &&
                              sortOrder == 'desc'
                            "
                            class="glyphicon glyphicon-triangle-bottom"
                          ></span>
                        </a>
                      </th>
                      <th style="width: 6%" class="text-center">
                        <a
                          class="table-header"
                          role="button"
                          @click="sortLocationData('LocationCountry')"
                        >
                          {{ lang.CM2020 }}
                          <span
                            v-if="
                              sortField == 'LocationCountry' &&
                              sortOrder == 'asc'
                            "
                            class="glyphicon glyphicon-triangle-top"
                          ></span>
                          <span
                            v-if="
                              sortField == 'LocationCountry' &&
                              sortOrder == 'desc'
                            "
                            class="glyphicon glyphicon-triangle-bottom"
                          ></span>
                        </a>
                      </th>
                      <th style="width: 25%" class="text-center">
                        <a
                          class="table-header"
                          role="button"
                          @click="sortLocationData('LocationAddress')"
                        >
                          {{ lang.CM2021 }}
                          <span
                            v-if="
                              sortField == 'LocationAddress' &&
                              sortOrder == 'asc'
                            "
                            class="glyphicon glyphicon-triangle-top"
                          ></span>
                          <span
                            v-if="
                              sortField == 'LocationAddress' &&
                              sortOrder == 'desc'
                            "
                            class="glyphicon glyphicon-triangle-bottom"
                          ></span>
                        </a>
                      </th>
                      <th style="width: 35%" class="text-center">
                        <a
                          class="table-header"
                          role="button"
                          @click="sortLocationData('LocationProperties')"
                        >
                          {{ lang.CM2022 }}
                          <span
                            v-if="
                              sortField == 'LocationProperties' &&
                              sortOrder == 'asc'
                            "
                            class="glyphicon glyphicon-triangle-top"
                          ></span>
                          <span
                            v-if="
                              sortField == 'LocationProperties' &&
                              sortOrder == 'desc'
                            "
                            class="glyphicon glyphicon-triangle-bottom"
                          ></span>
                        </a>
                      </th>
                      <th style="width: 6%" class="text-center">
                        <a
                          class="table-header"
                          role="button"
                          @click="sortLocationData('LocationStatusId')"
                        >
                          {{ lang.CM2023 }}
                          <span
                            v-if="
                              sortField == 'LocationStatusId' &&
                              sortOrder == 'asc'
                            "
                            class="glyphicon glyphicon-triangle-top"
                          ></span>
                          <span
                            v-if="
                              sortField == 'LocationStatusId' &&
                              sortOrder == 'desc'
                            "
                            class="glyphicon glyphicon-triangle-bottom"
                          ></span>
                        </a>
                      </th>
                      <th style="width: 6%" class="text-center">
                        <a
                          class="table-header"
                          role="button"
                          @click="sortLocationData('SurveyInstancesCount')"
                        >
                          {{ lang.CM2024 }}
                          <span
                            v-if="
                              sortField == 'SurveyInstancesCount' &&
                              sortOrder == 'asc'
                            "
                            class="glyphicon glyphicon-triangle-top"
                          ></span>
                          <span
                            v-if="
                              sortField == 'SurveyInstancesCount' &&
                              sortOrder == 'desc'
                            "
                            class="glyphicon glyphicon-triangle-bottom"
                          ></span>
                        </a>
                      </th>
                      <th style="width: 6%" class="text-center">
                        <a class="table-header">{{ lang.CM2009 }}</a>
                      </th>
                    </tr>
                    <tr class="table-filters">
                      <th class="nopadding" style="width: 8%">
                        <div class="form-group filterbar">
                          <input
                            type="search"
                            class="form-control text-center nopadding"
                            :placeholder="lang.CM2025"
                            v-model="filterStrings.LocationId"
                            @keyup.enter="(selectedPage = 1), getLocationData()"
                          />
                        </div>
                      </th>
                      <th class="nopadding" style="width: 8%">
                        <div class="form-group filterbar">
                          <input
                            type="search"
                            class="form-control text-center nopadding"
                            :placeholder="lang.CM2025"
                            v-model="filterStrings.LocationStoreId"
                            @keyup.enter="(selectedPage = 1), getLocationData()"
                          />
                        </div>
                      </th>
                      <th class="nopadding" style="width: 6%">
                        <div class="form-group filterbar">
                          <input
                            type="search"
                            class="form-control text-center nopadding"
                            :placeholder="lang.CM2025"
                            v-model="filterStrings.LocationCountry"
                            @keyup.enter="(selectedPage = 1), getLocationData()"
                          />
                        </div>
                      </th>
                      <th class="nopadding" style="width: 25%">
                        <div class="form-group filterbar">
                          <input
                            type="search"
                            class="form-control text-center nopadding"
                            :placeholder="lang.CM2025"
                            v-model="filterStrings.LocationAddress"
                            @keyup.enter="(selectedPage = 1), getLocationData()"
                          />
                        </div>
                      </th>
                      <th class="nopadding" style="width: 35%">
                        <div class="form-group filterbar">
                          <input
                            type="search"
                            class="form-control text-center nopadding"
                            :placeholder="lang.CM2025"
                            v-model="filterStrings.LocationProperties"
                            @keyup.enter="(selectedPage = 1), getLocationData()"
                          />
                        </div>
                      </th>
                      <th class="nopadding" style="width: 6%">
                        <div class="form-group filterbar">
                          <input
                            type="search"
                            class="form-control text-center nopadding"
                            :placeholder="lang.CM2025"
                            v-model="filterStrings.LocationStatusId"
                            @keyup.enter="(selectedPage = 1), getLocationData()"
                          />
                        </div>
                      </th>
                      <th class="nopadding" style="width: 6%">
                        <div class="form-group filterbar">
                          <input
                            type="search"
                            class="form-control text-center nopadding"
                            :placeholder="lang.CM2025"
                            v-model="filterStrings.SurveyInstancesCount"
                            @keyup.enter="(selectedPage = 1), getLocationData()"
                          />
                        </div>
                      </th>
                      <th class="nopadding" style="width: 6%">
                        <div class="form-group filterbar"></div>
                      </th>
                    </tr>
                  </thead>
                  <tbody class="main-table-scrollbar" id="create-checks-table">
                    <tr
                      role="button"
                      v-for="location in locationData"
                      :key="location.LocationId"
                      @click="toggleLocationSelected(location.LocationId)"
                      :class="{
                        info: isLocationSelected(location.LocationId),
                        'location-inactive': location.LocationStatusId === 'X',
                        'location-temp-inactive':
                          location.LocationStatusId === 'T',
                      }"
                    >
                      <!-- Add table data here -->
                      <td style="width: 8%">{{ location.LocationId }}</td>
                      <td style="width: 8%">{{ location.LocationStoreId }}</td>
                      <td style="width: 6%">{{ location.LocationCountry }}</td>
                      <td style="width: 25%">
                        {{ location.LocationAddress }}
                      </td>
                      <td style="width: 35%">
                        {{ location.LocationProperties }}
                      </td>
                      <td style="width: 6%">
                        {{ location.LocationStatusId }}
                      </td>
                      <td style="width: 6%">
                        {{ location.SurveyInstancesCount }}
                      </td>
                      <td style="width: 6%; padding: 0">
                        <div class="form-group">
                          <input
                            type="number"
                            min="0"
                            class="form-control nopadding"
                            v-model.number="location.Amount"
                            @click="$event.stopPropagation()"
                          />
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-raised" data-dismiss="modal">
              {{ lang.CM2039 }}
            </button>
            <button
              id="check-management-create"
              type="button"
              class="btn btn-raised dialog-btn-primary"
              @click="createChecks()"
              :disabled="
                selectedLocations.length < 1 ||
                !selectedSurvey ||
                !selectedScenario ||
                (!selectedUser && !selectedAgency && selectedCheckType !== 'FO')
              "
            >
              {{ lang.CM2026 }}
            </button>
          </div>
        </div>
      </div>
    </div>

    <AddChecksFurtherSettingsModal
      ref="addChecksFurtherSettingsModal"
      :showModal="showFurtherSettingsModal"
      :survey="selectedSurveyData"
      @modalClosed="furtherSettingsModalClosed"
    ></AddChecksFurtherSettingsModal>
  </div>
</template>

<script>
import Select2 from "../Tools/Select2";
import AddChecksFurtherSettingsModal from "./AddChecksFurtherSettingsModal";

export default {
  name: "CheckManagementAddModal",
  components: {
    Select2,
    AddChecksFurtherSettingsModal,
  },
  mounted() {
    if (this.globals.selectedLanguage) this.globals.getLanguageStrings(this);

    $("#addChecksDialog").on("hidden.bs.modal", (e) => {
      this.$emit("dialogClosed");
    });

    if (this.feature.isAudiTarget && this.feature.isEnabled("leadAgencies")) {
      this.globals.getAgencyTypeList((data) => {
        this.agencyTypeList = data;
      });
    }
  },
  computed: {
    leadAgencyGuid() {
      if (this.agencyTypeList.length < 1) return "";
      let leadAgency = _.find(
        this.agencyTypeList,
        (at) => at.AgencyTypeName === "Lead"
      );
      return leadAgency ? leadAgency.AgencyTypeGuid : "";
    },
    leadAgencies() {
      if (!this.leadAgencyGuid) return [];
      return this.dataLists.agencyList.filter(
        (a) => a.AgencyTypeGuid === this.leadAgencyGuid
      );
    },
  },
  methods: {
    // Initializes the dialog on opening
    openAddChecksDialog() {
      this.selectedClientLocal = this.selectedClient;
      this.selectedProjectLocal = "";
      if (this.selectedProject)
        this.$nextTick(() => {
          this.selectedProjectLocal = this.selectedProject;
        });
      this.selectedCheckType = "";
      if (this.feature.isAudiTarget) this.selectedCheckType = "AG";
      this.selectedAgency = "";
      this.selectedUser = "";
      this.globalAmount = 0;
      this.checkInfo = "";
      this.selectedBriefingGuid = "";
      this.selectedSurveyGuid = "";
      this.selectedLocations = [];
      this.amountList = [];
      this.createdChecks = [];
      this.createdCheckIds = [];
      this.$refs["addChecksFurtherSettingsModal"].clearSettings();
      this.clearFilterStrings();
      this.getLocationData(true);
      $("#addChecksDialog").modal("show");
    },

    // Closes the addChecksDialog
    closeAddChecksDialog() {
      $("#addChecksDialog").modal("hide");
      this.$emit("checksCreated", {
        guids: this.createdChecks,
        ids: this.createdCheckIds,
      });
    },

    clearFilter() {
      if (!this.feature.isAudiTarget) this.selectedClientLocal = "";
      this.selectedProjectLocal = "";
      this.selectedSurvey = "";
      this.selectedWave = "";
      this.selectedScenario = "";
      this.selectedUser = "";
      this.selectedAgency = "";
      this.globalAmount = 0;
      this.selectedLocations = [];
      this.amountList = [];
      this.clearFilterStrings();
      this.$forceUpdate();
    },

    clearFilterStrings() {
      let filterKeys = Object.keys(this.filterStrings);
      filterKeys.forEach((filterKey) => (this.filterStrings[filterKey] = ""));
    },

    sortLocationData(field) {
      if (field == this.sortField) {
        this.sortOrder == "asc"
          ? (this.sortOrder = "desc")
          : (this.sortOrder = "asc");
      } else {
        this.sortField = field;
        this.sortOrder = "asc";
      }
      this.selectedPage = 1;
      this.getLocationData();
    },

    toggleLocationSelected(locationId) {
      var idx = _.indexOf(this.selectedLocations, locationId);
      if (idx > -1) _.pullAt(this.selectedLocations, idx);
      else this.selectedLocations.push(locationId);
      this.$forceUpdate();
    },

    isLocationSelected(locationId) {
      return _.indexOf(this.selectedLocations, locationId) > -1;
    },

    isPageSelected() {
      for (let i = 0; i < this.locationData.length; i++) {
        if (!this.isLocationSelected(this.locationData[i].LocationId))
          return false;
      }
      return true;
    },

    togglePageSelected() {
      if (this.locationData.length < 1) return;
      var selState = this.isPageSelected();
      if (!selState) {
        for (let i = 0; i < this.locationData.length; i++) {
          if (!this.isLocationSelected(this.locationData[i].LocationId))
            this.selectedLocations.push(this.locationData[i].LocationId);
        }
      } else {
        for (let i = 0; i < this.locationData.length; i++) {
          this.toggleLocationSelected(this.locationData[i].LocationId);
        }
      }
    },

    getLocationData(discardAmounts) {
      if (
        !this.selectedClientLocal ||
        (!this.selectedProjectLocal &&
          this.feature.isAudiTarget &&
          this.feature.isEnabled("audi_importers"))
      ) {
        this.locationData = [];
        this.pageCount = 0;
        this.pageSize = 20;
        this.selectedPage = 1;
        return;
      }

      if (!discardAmounts) this.storeAmountsForPage();
      let getString = `api/SurveyInstances/Locations/${this.selectedClientLocal}?page_size=${this.pageSize}&page=${this.selectedPage}&sort_column=${this.sortField}&sort_order=${this.sortOrder}`;
      getString = encodeURI(getString);

      let filter = _.pickBy(this.filterStrings, (value, key) => {
        return value.length > 0;
      });

      let sendData = {};
      if (!_.isEmpty(filter)) sendData.Filter = filter;
      if (this.selectedProjectLocal)
        sendData.ProjectGuidForImporterFilter = this.selectedProjectLocal;

      $.ajax({
        method: "POST",
        url: getString,
        data: _.isEmpty(sendData) ? "" : JSON.stringify(sendData),
        dataType: "json",
        contentType: "application/json; charset=utf-8",
        success: (data) => {
          if (data[0]) {
            if (data[0].Locations) this.locationData = data[0].Locations;
            // If GET was successful, store location data and page count from server
            else this.locationData = [];
            this.pageCount = data[0].Page_Count;
            this.totalElementsCount = data[0].Count;
            this.readAmountsForPage();
          }
        },
        error: () => {
          console.error("Error on POST in getLocationData()");
          this.globals.showErrorSnackbar("Location data access failed");
        },
      });
    },

    createChecks() {
      this.storeAmountsForPage();
      this.removeUnselectedLocationsFromAmountList();
      this.setGlobalAmount();
      _.remove(this.amountList, (entry) => entry.Amount < 1);

      if (this.amountList.length < 1) {
        this.globals.showErrorSnackbar(this.lang.CM2042);
        console.error("Error creating checks: No amounts selected");
        return;
      }

      let sendData = {};
      if (this.selectedSurvey) sendData.Surveys = [this.selectedSurvey];
      if (this.selectedScenario && this.selectedWave)
        sendData.WavesScenarios = [
          { WaveGuid: this.selectedWave, ScenarioGuid: this.selectedScenario },
        ];
      if (this.selectedAgency) {
        if (this.feature.isAudiTarget)
          sendData.LeadAgencyGuid = this.selectedAgency;
        else sendData.LocalAgencyGuid = this.selectedAgency;
      }
      if (this.selectedUser) sendData.ShopperGuid = this.selectedUser;
      sendData.Locations = this.amountList;
      if (this.selectedCheckType)
        sendData.SurveyInstanceType = this.selectedCheckType;
      if (this.selectedBriefingGuid)
        sendData.BriefingDownloadGuid = this.selectedBriefingGuid;
      if (this.selectedSurveyGuid)
        sendData.SurveyDownloadGuid = this.selectedSurveyGuid;
      if (this.checkInfo) sendData.SurveyInstanceInfo = this.checkInfo;

      if (this.selectedCheckType === "FO") {
        for (let key in this.furtherCheckSettings) {
          if (
            this.furtherCheckSettings[key] ||
            typeof this.furtherCheckSettings[key] === "boolean"
          )
            sendData[key] = this.furtherCheckSettings[key];
        }
      }

      $.ajax({
        method: "POST",
        url: "api/SurveyInstances",
        data: JSON.stringify(sendData),
        dataType: "json",
        contentType: "application/json; charset=utf-8",
        success: (data) => {
          this.globals.showSuccessSnackbar(this.lang.CM2041);
          this.$emit("dialogDataSaved");
          this.amountList = [];
          this.selectedSurvey = "";
          this.selectedWave = "";

          if (_.isEmpty(data)) {
            console.error("Missing check IDs");
            return;
          }
          for (let check of data) {
            this.createdChecks.push(check.SurveyInstanceGuid);
            this.createdCheckIds.push(check.SurveyInstanceId);
          }
        },
        error: () => {
          console.error("Error on POST in createChecks()");
          this.globals.showErrorSnackbar(this.lang.CM2040);
        },
      });
    },

    setAmount(amount, locationIds) {
      var am = _.find(this.amountList, (a) => {
        return a.Amount == amount;
      });
      if (am) {
        am.LocationIds = _.union(am.LocationIds, locationIds);
      } else {
        let amountObj = { Amount: amount, LocationIds: locationIds };
        this.amountList.push(amountObj);
      }
    },

    setGlobalAmount() {
      if (!this.globalAmount) return;
      for (let i = 0; i < this.selectedLocations.length; i++) {
        if (!this.hasAmount(this.selectedLocations[i])) {
          this.setAmount(this.globalAmount, [this.selectedLocations[i]]);
        }
      }
    },

    hasAmount(locationId) {
      for (let i = 0; i < this.amountList.length; i++) {
        var locs = this.amountList[i].LocationIds;
        for (let j = 0; j < locs.length; j++) {
          if (locs[j] == locationId) return true;
        }
      }
      return false;
    },

    removeUnselectedLocationsFromAmountList() {
      for (let i = 0; i < this.amountList.length; i++) {
        let locs = this.amountList[i].LocationIds;
        for (let j = 0; j < locs.length; j++) {
          if (!this.isLocationSelected(locs[j])) _.pullAt(locs, j);
        }
        if (locs.length < 1) _.pullAt(this.amountList, i);
      }
    },

    storeAmountsForPage() {
      for (let i = 0; i < this.locationData.length; i++) {
        if (this.locationData[i].Amount) {
          this.setAmount(this.locationData[i].Amount, [
            this.locationData[i].LocationId,
          ]);
        }
      }
    },

    readAmountsForPage() {
      if (this.amountList.length < 1) return;
      for (let i = 0; i < this.amountList.length; i++) {
        var locs = this.amountList[i].LocationIds;
        for (let j = 0; j < locs.length; j++) {
          var ld = _.find(this.locationData, (l) => {
            return l.LocationId == locs[j];
          });
          if (ld) {
            ld.Amount = this.amountList[i].Amount;
          }
        }
      }
    },

    updatePaging(pageNumber, pageSize) {
      this.selectedPage = pageNumber || 1;
      if (pageSize != 0) this.pageSize = pageSize;
      this.getLocationData();
    },

    // Returns a range of numbers with min-value, max-value and stepsize
    getRange(min, max, step) {
      var range = [],
        j = 0;
      for (var i = min; i <= max; i += step) {
        range[j++] = i;
      }
      return range;
    },

    // Returns a list of all pagenumbers that should be visible depending on the current page and the count of pages
    getVisiblePages() {
      if (this.pageCount <= 7) {
        return this.getRange(1, this.pageCount, 1);
      } else if (this.pageCount > 7 && this.selectedPage <= 4) {
        return this.getRange(1, 6, 1);
      } else if (
        this.pageCount > 7 &&
        this.selectedPage >= this.pageCount - 3
      ) {
        return this.getRange(this.pageCount - 5, this.pageCount, 1);
      } else {
        return this.getRange(this.selectedPage - 2, this.selectedPage + 2, 1);
      }
    },
    getProjectAttachments() {
      let queryString = `/api/data/ProjectAttachments/${this.selectedProjectLocal}`;
      $.ajax({
        method: "GET",
        url: queryString,
        success: (data) => {
          if (data.length > 0) {
            this.briefingAttachments = data.filter(
              (d) => d.AttachmentType === "Briefing"
            );
            this.surveyAttachments = data.filter(
              (d) => d.AttachmentType === "Survey"
            );
          }
        },
        error: () => {
          console.error(
            "Attachments data access failed in getProjectAttachments()"
          );
          this.globals.showErrorSnackbar(this.lang.CM2043);
        },
      });
    },
    furtherSettingsModalClosed(data) {
      this.showFurtherSettingsModal = false;
      this.furtherCheckSettings = data;
    },
  },
  watch: {
    showDialog(newValue) {
      if (newValue) this.openAddChecksDialog();
      else this.closeAddChecksDialog();
    },
    selectedClientLocal(newValue) {
      if (newValue) {
        let pl = this.dataLists.projectList.find((p) => {
          return p.ClientGuid === newValue;
        });
        if (pl && pl.Projects) this.projectsOfClient = pl.Projects;
        else this.projectsOfClient = [];
      }
      this.selectedProjectLocal = "";
      this.selectedLocations = [];
      this.amountList = [];
      this.getLocationData(true);
    },
    selectedProjectLocal(newValue) {
      if (newValue) {
        let sl = this.dataLists.surveyList.find((s) => {
          return s.ProjectGuid === newValue;
        });
        if (sl && sl.Surveys) this.surveysOfProject = sl.Surveys;
        else this.surveysOfProject = [];

        let wl = this.dataLists.waveList.find((w) => {
          return w.ProjectGuid === newValue;
        });
        if (wl && wl.Waves) this.wavesOfProject = wl.Waves;
        else this.wavesOfProject = [];

        this.getProjectAttachments();
      }
      this.selectedSurvey = "";
      this.selectedWave = "";

      if (
        this.feature.isAudiTarget &&
        this.feature.isEnabled("audi_importers")
      ) {
        this.selectedLocations = [];
        this.amountList = [];
        this.getLocationData(true);
      }
    },
    selectedWave(newValue) {
      if (newValue) {
        let scl = this.dataLists.scenarioList.find((s) => {
          return s.WaveGuid === newValue;
        });
        if (scl && scl.Scenarios) this.scenariosOfWave = scl.Scenarios;
        else this.scenariosOfWave = [];
      }
      this.selectedScenario = "";
    },
    selectedUser(newValue) {
      if (!newValue) return;
      this.selectedAgency = "";
    },
    selectedAgency(newValue) {
      if (!newValue) return;
      this.selectedUser = "";
    },
    selectedSurvey(id) {
      if (!id) this.selectedSurveyData = {};
      else
        this.selectedSurveyData =
          _.find(this.surveysOfProject, (s) => {
            return s.SurveyId == id;
          }) || {};
    },
    "globals.selectedLanguage"() {
      this.globals.getLanguageStrings(this);
    },
  },
  props: ["dataLists", "selectedClient", "selectedProject", "showDialog"],
  data() {
    // Global data inside the component is stored here
    return {
      selectedPage: 1,
      pageSize: 20,
      pageCount: 0,
      totalElementsCount: 0,
      sortOrder: "asc",
      sortField: "LocationId",
      filterStrings: {
        Search: "",
        LocationId: "",
        LocationStoreId: "",
        LocationCountry: "",
        LocationAddress: "",
        LocationProperties: "",
        LocationStatusId: "",
        SurveyInstancesCount: "",
      },
      locationData: [],
      selectedLocations: [],
      projectsOfClient: [],
      surveysOfProject: [],
      wavesOfProject: [],
      scenariosOfWave: [],
      agencyTypeList: [],
      selectedClientLocal: -1,
      selectedProjectLocal: "",
      selectedSurvey: "",
      selectedSurveyData: {},
      selectedWave: "",
      selectedScenario: "",
      selectedUser: "",
      selectedAgency: "",
      selectedBriefingGuid: "",
      selectedSurveyGuid: "",
      selectedCheckType: "",
      globalAmount: 0,
      checkInfo: "",
      amountList: [],
      briefingAttachments: [],
      surveyAttachments: [],
      createdChecks: [],
      createdCheckIds: [], //TODO: should be removed
      furtherCheckSettings: {
        OnlineState: false,
        LocationFree: false,
      },
      showFurtherSettingsModal: false,
      lang: {
        CM2000: "Create Checks",
        CM2001: "Select Client...",
        CM2002: "Select Project...",
        CM2003: "Select Survey...",
        CM2004: "Select Wave...",
        CM2005: "Select Scenario...",
        CM2006: "Select Shopper...",
        CM2007: "Begin",
        CM2008: "End",
        CM2009: "Amount",
        CM2010: "Clear Filter",
        CM2011: "Select Page",
        CM2012: "Deselect Page",
        CM2013: "Select Agency...",
        CM2014: "Search...",
        CM2015: "Elements per page",
        CM2016: "First page",
        CM2017: "Last page",
        CM2018: "Location ID",
        CM2019: "Location Store ID",
        CM2020: "Country",
        CM2021: "Location Address",
        CM2022: "Location Properties",
        CM2023: "Status Location",
        CM2024: "Existing Checks",
        CM2025: "Filter",
        CM2026: "Create",
        CM2027: "Check Description",
        CM2028:
          "It is not allowed to create checks with an amount of 0 surveys",
        CM2029: "Choose briefing document...",
        CM2030: "Choose survey document...",
        CM2031: "Select check type",
        CM2032: "Free offer",
        CM2033: "Manual assignment",
        CM2034: "Agency",
        CM2035: "Check refund",
        CM2036: "Reset",
        CM2037: "Selected locations",
        CM2038: "Offer details",
        CM2039: "Close",
        CM2040: "Check creation failed",
        CM2041: "Check creation successful",
        CM2042: "No amounts selected",
        CM2043: "Attachment data access failed",
        CM2044: "Check Info",
        CM2045: "Total locations count",
      },
    };
  },
};
</script>

<style scoped>
#addChecksDialog > .modal-dialog {
  width: calc(100vw - 60px);
}
#addChecksDialog .modal-body {
  height: calc(100vh - 160px);
  overflow: auto;
}

#addChecksDialog .modal-content {
  background-color: #eee;
}

.form-group.input-form-group > div,
.form-group.input-form-group > label {
  padding: 0;
}

.form-group-buttons {
  text-align: left;
}
.form-group-buttons > a {
  margin: 2px;
  padding: 6px 10px;
}
.last-row-button-container {
  margin-top: 10px;
}

.locations-table-panel {
  margin-bottom: 0;
}

.location-inactive {
  color: orange;
}
.location-temp-inactive {
  color: rgb(182, 182, 182);
}

.selected-locations-counter {
  float: left;
  margin-top: 8px;
  color: rgb(17, 0, 201);
}
.selected-locations-counter > a {
  cursor: pointer;
  padding: 3px;
  margin: -3px 0 0 5px;
}
</style>



// WEBPACK FOOTER //
// CheckManagementAddModal.vue?c58a9970